import { render } from "./RecentBestAll.vue?vue&type=template&id=2ab70688"
import script from "./RecentBestAll.vue?vue&type=script&lang=js"
export * from "./RecentBestAll.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__